import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DRIVER_GROUP_CONFIG;

import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import { isNonMonetizing } from '@nerdwallet/marketplace/utils';
import { getTermsAndFeesLink } from '@nerdwallet/cc-utils/lib/offer-api/selectors';
import { DEFAULT_DRIVER_GROUP, getDrivers } from '../../utils';

/**
 * Export all the keys of overridable driverGroups
 */
export var DRIVER_GROUPS_CREDIT_CARDS = {
  CC_BALANCE_TRANSFER: 'CC_BALANCE_TRANSFER',
  CC_CLASSIC_DEFAULT: 'CC_CLASSIC_DEFAULT',
  CC_REWARDS: 'CC_REWARDS'
};
/**
 * @param {Object} args -
 * @param {Object} args.marketplaceEntity -
 * @returns {Object[]} - list of quick-fact objects.
 */

var getClassicDefaultDrivers = function getClassicDefaultDrivers(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return [quickFactMappings.creditCards.getQuickFactAnnualFee(marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(marketplaceEntity), quickFactMappings.creditCards.getQuickFactIntroApr(marketplaceEntity)];
};

var getRewardsDrivers = function getRewardsDrivers(_ref2) {
  var marketplaceEntity = _ref2.marketplaceEntity;
  return [quickFactMappings.creditCards.getQuickFactAnnualFee(marketplaceEntity), quickFactMappings.creditCards.getQuickFactRewardRate(marketplaceEntity), quickFactMappings.creditCards.getQuickFactIntroOffer(marketplaceEntity)];
};
/**
 * Get drivers for CC_BALANCE_TRANSFER driver group
 */


var getBalanceTransferDrivers = function getBalanceTransferDrivers(_ref3) {
  var marketplaceEntity = _ref3.marketplaceEntity;
  return [quickFactMappings.creditCards.getQuickFactAnnualFee(marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(marketplaceEntity), quickFactMappings.creditCards.getQuickFactIntroApr(marketplaceEntity), quickFactMappings.creditCards.getQuickFactBalanceTransferFeeDescription(marketplaceEntity)];
};
/**
 * Define config of how to create drivers based off a driverGroup and other props
 */


var DRIVER_GROUP_CONFIG = (_DRIVER_GROUP_CONFIG = {}, _defineProperty(_DRIVER_GROUP_CONFIG, DEFAULT_DRIVER_GROUP, getRewardsDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_CLASSIC_DEFAULT, getClassicDefaultDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BALANCE_TRANSFER, getBalanceTransferDrivers), _DRIVER_GROUP_CONFIG);
export default (function (_ref4) {
  var driverGroup = _ref4.driverGroup,
      marketplaceEntity = _ref4.marketplaceEntity;
  var secondaryCtaProps = {};

  if (!isNonMonetizing(marketplaceEntity)) {
    secondaryCtaProps.secondaryCtaText = 'Rates & Fees';
    secondaryCtaProps.secondaryCtaHref = getTermsAndFeesLink(marketplaceEntity);
  }

  return _objectSpread({
    drivers: getDrivers({
      driverGroupConfig: DRIVER_GROUP_CONFIG,
      driverGroup: driverGroup,
      marketplaceEntity: marketplaceEntity
    })
  }, secondaryCtaProps);
});